import { botsList } from '../constants/bots-list.constants';

export function botDetector(useragent: string) {
    const botPattern = `(${botsList.join('|')})`;
    const re = new RegExp(botPattern, 'i');
    return re.test(useragent) ? true : false;
}
